import {useAppConfig} from '@/hooks/use-app-config'
import {useI18n} from '@/i18n'
import {MutedText} from '@/components/shared/MutedText'

/**
 * Persistent footer surfacing the backend build identifiers (version, git
 * tag, git branch). Runs across the entire app shell so operators / support
 * engineers can see at a glance which build a tenant is on (issues 632 + 650).
 */
export function Footer() {
    const i18n = useI18n()
    const {backendVersion, backendGitTag, backendGitBranch} = useAppConfig()
    const tag = (backendGitTag ?? '').trim()
    const branch = (backendGitBranch ?? '').trim()
    return (
        <footer className="mt-8 border-t" data-testid="app-footer">
            <div className="px-4 py-2 text-right">
                <MutedText size="xs" data-testid="footer-version">
                    {i18n.common.version}{' '}{backendVersion}
                    {tag !== '' && (
                        <span data-testid="footer-git-tag" className="before:content-['·'] before:mx-1">{tag}</span>
                    )}
                    {branch !== '' && (
                        <span data-testid="footer-git-branch" className="before:content-['·'] before:mx-1">{branch}</span>
                    )}
                </MutedText>
            </div>
        </footer>
    )
}
